<template>
	<div class="usdt_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.push('/user')" />
			<div class="big_tit">
				{{ data.payment.name }}
			</div>
		</div>
		<div class="cont">
			<div class="code_box">
				<div class="money">
					{{ $t('utils.moneyMark') }}{{ money }}
					<span>{{ actualAmount }}</span>
				</div>
				<div v-if="data.payment.type==1">
					{{ $t('invest_qrcode.scanQRcode') }}
				</div>
				<div class="qrcode_img">
					<img class="qrcode" :src="data.payment.qrcode" alt="">
				</div>
				<div v-if="data.payment.type==1" class="wallet">
					{{ $t('invest_qrcode.walletAddress') }}
				</div>
				<div v-if="data.payment.type==1" class="walletAddress">
					{{ data.payment.address }}
				</div>
			</div>
			<div v-if="data.payment.type==1" class="button_box">
				<div v-clipboard="() => data.payment.address" v-clipboard:success="copy" class="copy_link"
					@click="copyAddress">
					{{ $t('invest_qrcode.copyWalletAddress') }}
				</div>
			</div>
			</br>
			<div class="card">
				<div class="upload-card">
					<van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"
						:after-read="(file)=>{ afterRead(file, 'idCardHead') }" :before-read="beforeRead"
						@delete="(file)=> { delFile(file,'idCardHead') }">
						<div class="upload-action">
							<img class="upload-icon" src="@/assets/img/upload.png" alt="">
							<div class="upload-text">
								{{ $t('lh.上传交易凭证截图') }}
							</div>
						</div>
					</van-uploader>
				</div>
			</div>

			<div class="basic_btn" @click="submitBtn">
				{{ $t('utils.submit') }}
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	import {
		Toast
	} from 'vant';
	import axios from 'axios';
	Vue.use(Clipboard);
	export default {
		name: "InvestQrcode",
		data() {
			return {
				data: {},
				money: 0,
				actualAmount: '',
				fileList: [],
				img: ''
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.money = this.$route.query.money;
			this.start();
		},
		methods: {
			beforeRead(file) {
				if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
					this.$toast(this.$t('account.supportPicture'));
					return false;
				}
				return true;
			},
			afterRead(file, key) {
				let formData = new FormData();
				formData.append('language', this.$i18n.locale || "en_us");
				formData.append('file', file.file);
				formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.img = r.data.data
						// this.bank.img = r.data.data;
					} else {
						if (r.data.info) {
							this.$toast(r.data.info);
						} else {
							this.$toast(this.$t('account.uploadFail'));
						}
					}
				});
			},
			delFile(file, key) {
				this.img = ''
			},
			start() {
				Fetch('/user/recharge_type', {
					money: this.$route.query.money ? this.$route.query.money : "",
					id: this.$route.query.id ? this.$route.query.id : ""
				}).then((r) => {
					this.data = r.data;
					this.changeAmount();
				}).catch(() => {
					setTimeout(() => {
						this.$router.back();
					}, 1000)
				})
			},
			submitBtn() {
				if (!this.img) {
					this.$toast(this.$t('lh.上传交易凭证截图'));
					return;
				}
				Fetch("/user/recharge_apply", {
					id: this.data.orderId,
					img: this.img
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				});
			},
			copyAddress() {
				this.mask_show = true;
				var that = this;
				var local = window.location.origin;
				var url = local + this.data.down_image;
			},
			copy() {
				this.$toast({
					background: '#07c160',
					message: this.$t('invest_qrcode.copySucceeded')
				})
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment
						.mark + ")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(
						num) + ")";
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.upload-icon {
		width: 40px;
		height: 40px;
	}

	.upload-text {
		margin-top: .5rem;
		font-size: .8rem;
		color: rgb(239, 216, 196) !important;
	}

	.upload-action {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	/deep/ .van-dropdown-menu__bar {
		box-shadow: none;
	}

	/deep/ .van-uploader__wrapper {
		text-align: center;
		width: 50%;
		height: 50%;
	}

	/deep/ .van-uploader__preview {
	
		width: 50%;
		height: 50%;
		margin: 0 !important;
	}

	/deep/ .van-uploader__preview-image {
		width: 100%;
		height: 100%;
	}

	/deep/ .van-uploader__input-wrapper {
		width: 100%;
		height: 100%;
	}

	/deep/ .van-button--primary {
		background-color: transparent;
		border: none;
		width: 100%;
		height: 100%;
	}

	/deep/ .van-uploader {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.usdt_wrap {
		width: 100%;
		height: 100vh;
		position: fixed;
	}

	.red_top_bg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background: rgb(35, 29, 29) !important;
		color: rgb(239, 216, 196) !important;

		.back_left {
			color: rgb(239, 216, 196) !important;
		}

		.big_tit {
			color: rgb(239, 216, 196) !important;
		}
	}

	.cont {
		height: calc(100vh - 44px);
		margin-top: 44px;
		overflow-y: scroll;
		background: url('../../assets/img/home-bg.jpg') repeat center;
		background-size: 100%;
	}

	.button_box {
		width: 90%;
		margin-left: 5%;
		height: 60px;
		background: #ebedf0;
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: -10px;
		display: flex;
		text-align: center;

		.copy_link {
			width: 100%;
			line-height: 60px;
		}
	}

	.code_box {
		width: 90%;
		margin-left: 5%;
		padding: 30px 0;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.money {
			color: #000;
			font-size: 26px;

			span {
				font-size: 14px;
				color: #999;
			}
		}

		.wallet {
			margin-top: 10px;
		}

		.walletAddress {
			text-align: center;
			color: #000;
			width: 80%;
		}

		div {
			color: #999;
			font-size: 14px;
			margin-bottom: 15px;
		}

		.qrcode_img {
			width: 200px;
			height: 200px;
			margin: 0 auto;
			text-align: center;
			background: linear-gradient(to left, #999, #999) left top no-repeat,
				linear-gradient(to bottom, #999, #999) left top no-repeat,
				linear-gradient(to left, #999, #999) right top no-repeat,
				linear-gradient(to bottom, #999, #999) right top no-repeat,
				linear-gradient(to left, #999, #999) left bottom no-repeat,
				linear-gradient(to bottom, #999, #999) left bottom no-repeat,
				linear-gradient(to left, #999, #999) right bottom no-repeat,
				linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;

			span {
				line-height: 220px;
			}

			img {
				width: 190px;
				height: 190px;
				margin-top: 5px;
			}
		}

		p {
			font-size: 15px;
			line-height: 21px;
			color: #000;
			font-weight: bold;
			margin-top: 13px;
		}

		.address_left {
			width: 90%;
			text-align: left;
		}
	}

	.warming {
		margin-top: 17px;
		padding: 0 14px;

		.tit {
			font-size: 14px;
			color: rgba(0, 0, 0, .8);
			line-height: 20px;
			font-weight: bold;
		}

		.content {
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			line-height: 17px;
			margin-top: 9px;
		}
	}

	.basic_btn {
		margin: 30px auto 0 auto;
		background: linear-gradient(90deg, #672ee4 0%, #16b4ff 100%);
	}
</style>